import { INITIAL_BALANCES_REQUEST, FETCH_BALANCES_SUCCESS } from "../../types/maintainers/balances.type";

const initialState = {
	customers: [],
	estates: [],
	estates_parents: [],
	status: [],
	balances: [],
	version: {},
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_balances(state = initialState, action) {
	switch (action.type) {
		case INITIAL_BALANCES_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case FETCH_BALANCES_SUCCESS:
			return {
				...state,
				customers: action.payload.customers,
				estates: action.payload.estates,
				estates_parents: action.payload.estates_parents,
				status: action.payload.status,
				balances: action.payload.balances,
				version: action.payload.version,
				isFetching: false,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		default:
			return state;
	}
}

export default maintainers_balances;
